import apiPaths from '../api-paths';

/**
 * Podsumowania wartości nad listami faktur (PUB-1595).
 *
 * `filters` to DOKŁADNIE ten sam obiekt, który leci do listy (`$route.query.filters`) — parytet
 * filtrów wynika z konstrukcji, a nie z osobnej logiki. Regułę kwalifikacji dokumentów
 * (manualne / automatyczne / nieopłacone) ustawia serwer na podstawie trasy.
 */
const summaryParams = ({ filters, selectedOriginals }) => ({
  filters,
  // Tryb „Zaznaczone" (PUB-1627): wyłącznie `original` zaznaczonych dokumentów, bez ich treści.
  ...(selectedOriginals?.length ? { selected_originals: selectedOriginals.join(',') } : {}),
});

export default {
  getManualSummary({ filters, selectedOriginals, signal } = {}) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/invoices/manual/summary`, { params: summaryParams({ filters, selectedOriginals }), signal });
  },
  getAutomaticSummary({ filters, selectedOriginals, signal } = {}) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/invoices/automatic/summary`, { params: summaryParams({ filters, selectedOriginals }), signal });
  },
  getPaymentDueSummary({ filters, selectedOriginals, signal } = {}) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/invoices/payment-due/summary`, { params: summaryParams({ filters, selectedOriginals }), signal });
  },
};
